<template>
	<form class="wide" @submit.prevent="submit">
		<loader v-if="!formReady"/>
		<div v-if="formReady">
			<fieldset>
				<div>
					<div>
						<legend><span>Complete</span></legend>
						<div class="help-block">
							<p>Specify the final value of this service, as well as any additional services and those final values.</p>
						</div>
					</div>
					<div>
						<table>
							<thead>
								<tr>
									<th align="left">Service</th>
									<th align="left">Value</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td v-html="instruction.service.names.singular"/>
									<td v-if="!instruction.requires_value_to_complete">—</td>
									<td v-if="instruction.requires_value_to_complete">
										<div v-if="form.errors.get('value')" class="error-block">
											<p v-html="form.errors.get('value')"></p>
										</div>
										<input v-model="form.data.value" type="text">
									</td>
								</tr>
								<tr v-for="(service, serviceIndex) in additionalServices" :key="service.id">
									<td v-html="service.names.singular"/>
									<td v-if="!'percent' === service.pivot.commission_type">—</td>
									<td v-if="'percent' === service.pivot.commission_type">
										<div
											v-if="form.errors.get('additional_services.' + service.id + '.value')"
											class="error-block">
											<p v-html="form.errors.get('additional_services.' + service.id + '.value')"></p>
										</div>
										<input v-model="form.data.additional_services[service.id].value" type="text">
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</fieldset>
			<div class="actions-aligned">
				<ul class="actions">
					<li>
						<button
							:disabled="form.processing" class="button button--secondary"
							@click.prevent="$parent.toggle('completing', false)">Cancel
						</button>
					</li>
					<li>
						<process-button :processing="form.processing" class="button button--primary" text="Complete"/>
					</li>
				</ul>
			</div>
		</div>
	</form>
</template>
<script>

export default {

	data() {
		return {
			formReady: false,
			form: this.newForm({
				value: "",
				additional_services: [{
					value: null,
				}],
			}),
		};
	},

	props: {
		instruction: {
			required: true,
			type: Object,
		},
	},

	computed: {
		additionalServices() {
			let instructionService = this.instruction.service;
			return _.filter(this.form.options.services, function (service) {
				return service.id !== instructionService.id;
			});
		},
	},

	methods: {
		async submit() {
			this.form.patch("instructions/" + this.instruction.id + "/complete").then(response => {
				let store = this.$store;
				store.commit("clients/INSTRUCTION_UPDATED", response.data);
				store.commit("instructions/UPDATE_ITEM", response.data);
				this.$store.dispatch("alertsStore/success", "Instruction Completed");
				this.$parent.toggle("completing", false);
			});
		},
	},

	created() {
		http().get("instructions/" + this.instruction.id + "/complete").then(response => {
			this.form.setOptions(response.data);

			this.form.setKeys("additional_services", _.map(this.additionalServices, function (service) {
				return service.id;
			}));

			this.formReady = true;
		});
	},
};
</script>
